import {StyleSheet} from 'react-native';

// Theme-aware styles factory (docs/DARK-MODE.md). Style-as-function entries
// (tagContainer, buttonsContainer, button) are preserved — the factory returns
// them closed over the theme's colors.
const makeStyles = colors =>
  StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: colors.backgroundMuted,
    },
    marginHorizontal24: {
      marginHorizontal: 24,
    },
    marginVertical16: {
      marginVertical: 16,
    },
    marginTop16: {
      marginTop: 16,
    },
    pageViewContainer: {
      marginBottom: 16,
      marginTop: 16,
    },
    tagContainer: index => ({
      padding: 8,
      borderRadius: 8,
      backgroundColor: colors.surface,
      marginLeft: index == 0 ? 0 : 16,
    }),
    emptyListContainer: {
      marginTop: 100,
      marginBottom: 50,
      alignItems: 'center',
    },
    buttonsContainer: bottom => ({
      flexDirection: 'row',
      marginHorizontal: 24,
      marginBottom: bottom,
    }),
    button: leftMargin => ({
      flex: 1,
      marginLeft: leftMargin,
    }),
  });

export default makeStyles;
